import { useAppDispatch, useAppSelector } from 'reduxTyped'

import { segmentsActions } from 'common/filter/actions/segments'
import { getSegments } from 'common/filter/selectors/segments'
import { useDidMountEffect } from 'utils/commonHooks'

interface UseSegmentsOptions {
  /**
   * Forces to refetch segments
   */
  force?: boolean
}

export function useSegments({ force = false }: UseSegmentsOptions = {}) {
  const dispatch = useAppDispatch()
  const state = useAppSelector(getSegments)

  useDidMountEffect(() => {
    dispatch(
      segmentsActions.getListFx({
        payload: undefined,
        effectConfig: {
          forceRequest: force,
        },
      }),
    )
  })

  return state
}
